import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import "./inYour.scss";

function InYourSystem({ title, sectionText }) {
  return (
    <Fragment>
      <h1>{title}</h1>
      <p>{sectionText}</p>
    </Fragment>
  )
}


function InYour() {

  const { t } = useTranslation()

  return (
    <div className="container-in-your">
      <div className="texts-in-your">
        <InYourSystem title={t("whitelabel.in_your.crm.title")} sectionText={t("whitelabel.in_your.crm.section_text")} />
        <InYourSystem title={t("whitelabel.in_your.erp.title")} sectionText={t("whitelabel.in_your.erp.section_text")} />
        <InYourSystem title={t("whitelabel.in_your.portal.title")} sectionText={t("whitelabel.in_your.portal.section_text")} />

        <h1>{t("whitelabel.in_your.site.title")}</h1>
        <p>{t("whitelabel.in_your.site.section_text_1")}</p>
        <p>{t("whitelabel.in_your.site.section_text_2")}</p>


        <InYourSystem title={t("whitelabel.in_your.app.title")} sectionText={t("whitelabel.in_your.app.section_text")} />
        <InYourSystem title={t("whitelabel.in_your.views.title")} sectionText={t("whitelabel.in_your.views.section_text")} />
        <InYourSystem title={t("whitelabel.in_your.sso.title")} sectionText={t("whitelabel.in_your.sso.section_text")} />
        <InYourSystem title={t("whitelabel.in_your.two_way.title")} sectionText={t("whitelabel.in_your.two_way.section_text")} />
      </div>
    </div>
  );
}

export default InYour;
